import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getStockWarehousesForStockAdjustment = async (docNo) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/seller-po/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehousesForStockAdjustment - error", error)
        return handleApiError(error)
    }
}

export const getCreditNoteStockDataByWarehouseId = async (warehouseId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/credit-note/${warehouseId}`);
        return await response.data;
    } catch (error) {
        console.log("getCreditNotesByWarehouseId - error", error)
        return handleApiError(error)
    }
}

export const getClientHoldCreditNotesByWarehouseId = async (warehouseId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/credit-note/client-hold/${warehouseId}`);
        return await response.data;
    } catch (error) {
        console.log("getCreditNotesByWarehouseId - error", error)
        return handleApiError(error)
    }
}

export const getScrapStockByMaterialIdAndWarehouseId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/scrap-stock`, data);
        return await response.data;
    } catch (error) {
        console.log("getScrapStockByMaterialIdAndWarehouseId - error", error)
        return handleApiError(error)
    }
}


export const insertStockAdjustment = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/insert/add-stock-adjustment`, data);
        return await response.data;
    } catch (error) {
        console.log("insertStockAdjustment - error", error)
        return handleApiError(error)
    }
}

export const reverseStockAjustment = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/insert/reverse-stock-adjustment`, data);
        return await response.data;
    } catch (error) {
        console.log("reverseStockAjustment - error", error)
        return handleApiError(error)
    }
}

export const processCreditNoteRejectedStock = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/process-reject`, data);
        return await response.data;
    } catch (error) {
        console.log("processCreditNoteRejectedStock - error", error)
        return handleApiError(error)
    }
}

export const releaseClientHoldCreditNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/client-hold`, data);
        return await response.data;
    } catch (error) {
        console.log("processCreditNoteRejectedStock - error", error)
        return handleApiError(error)
    }
}

export const insertManufactureStockAdjustment = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/insert/add-manufacture-stock-adjustment`, data);
        return await response.data;
    } catch (error) {
        console.log("insertStockAdjustment - error", error)
        return handleApiError(error)
    }
}

export const insertSellerDebitNoteFromSmartStock = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment//sdn-from-smart-stock`, data);
        return await response.data;
    } catch (error) {
        console.log("insertStockAdjustment - error", error)
        return handleApiError(error)
    }
}

export const getStockWarehousesForCreateSellerDebitNote = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-adjustment/create-seller-debit-note`, data);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehousesForCreateSellerDebitNote - error", error)
        return handleApiError(error)
    }
}